import { Table, TableHeader, TableHead, TableBody, TableRow, TableCell } from "../ui/table";

type SpecsTableData = {
  _type: "specsTable";
  title: string;
  motor: string;
  battery: string;
  drive_system: string;
  gear: string;
  load_capacity: string;
  weight: string;
  wheel_dimensions: string;
};

type SpecRows = Omit<SpecsTableData, "_type" | "title">;

const rowTitles: Record<keyof SpecRows, string> = {
  motor: "Motor",
  battery: "Batteri",
  drive_system: "Drivsystem",
  gear: "Gir",
  load_capacity: "Lastekapasitet",
  weight: "Vekt",
  wheel_dimensions: "Hjuldimensjoner"
};

const SpecsTable = ({ data }: { data: SpecsTableData }) => {
  const { _type: _, title, ...rest } = data;

  // We all know javascript is weird.
  // We also know that the groq queries used create objects that are a bit weird.
  // To ensure that the data rendered in this table is actually just specs data, I've chosen to explicitly assign them here.
  const rows: Record<keyof SpecRows, string> = {
    motor: rest.motor,
    battery: rest.battery,
    drive_system: rest.drive_system,
    gear: rest.gear,
    load_capacity: rest.load_capacity,
    weight: rest.weight,
    wheel_dimensions: rest.wheel_dimensions
  };

  return (
    <Table className="pointer-events-none">
      <TableHeader>
        <TableRow>
          <TableHead className="font-bold p-2 text-black">
            <h3>{title}</h3>
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody className="[&>*:nth-child(odd)]:bg-[color:var(--color-peach-40)]">
        {Object.entries(rows).map(([k, value], index) => {
          // This assigned is to satisfy Typescript.
          // At this point, we know this assignment is true.
          const key = k as keyof SpecRows;

          return (
            <TableRow
              key={index}
              className="[&>*]:text-[18px] [&>*]:md:text-[20px] flex w-full gap-4 justify-evenly"
            >
              <TableCell className="min-w-max w-full md:w-1/2 font-bold">
                {rowTitles[key]}
              </TableCell>
              <TableCell className="min-w-1/2 w-full md:w-1/2 self-center text-[color:var(--color-grey-40)]">
                <p className="text-left">{value}</p>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default SpecsTable;
